export default __webpack_public_path__ + "static/media/541.1b8ff63a.svg";